import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Modals from '../../../../shared/types/enums/modals';
import Screen from '../../../../shared/utils/screen';
import styled, { CSSObject } from 'styled-components';
import { store } from '../../../../shared/store/store';

const getModalStyle = (): CSSObject => {
  const { modal } = store.getState();
  switch (modal.current) {
    case Modals.ACTIVATE_GENERIC:
    case Modals.ACTIVATE_ZAPPER:
      return {
        top: `${284 * Screen.widthRatio}px`,
      };
    case Modals.ANONYMOUS_GENERIC:
    case Modals.ANONYMOUS_ZAPPER:
      return {
        top: `${413 * Screen.widthRatio}px`,
      };
    case Modals.CLOSE_PLAYER:
    case Modals.DEADMAN_ZAPPER:
    case Modals.EXIT_APP:
      return {
        top: `${380 * Screen.widthRatio}px`,
      };
    case Modals.UPGRADE_RECORD_PLAN:
      return {
        top: `${325 * Screen.widthRatio}px`,
        width: `${1536 * Screen.widthRatio}px`,
        color: `${Colors['light']}`,
      };
    case Modals.LOGOUT:
      return {
        top: `${380 * Screen.widthRatio}px`,
        width: `${1036 * Screen.widthRatio}px`,
      };
    case Modals.PARENTAL_PIN_GENERIC:
      return {
        top: `${192 * Screen.widthRatio}px`,
      };
    case Modals.PARENTAL_PIN_ZAPPER:
      return {
        top: `${330 * Screen.widthRatio}px`,
      };
    case Modals.GENERIC_ERROR:
    case Modals.PLAYER_ERROR:
      return {
        position: 'unset',
        margin: `${10 * Screen.widthRatio}px auto`,
        top: `${190 * Screen.widthRatio}px`,
      };
    case Modals.RECORDING_REQUEST:
      return {
        color: `${Colors['light']}`,
        'font-family': `${Fonts['regular']}`,
        top: `${496 * Screen.widthRatio}px`,
      };
  }
  return {};
};

interface ModalTitleProps {
  color?: string;
  width?: string;
}

const ModalTitle = styled.span<ModalTitleProps>`
  color: ${(props) => props.color || Colors['modal']['title']};
  font-family: ${Fonts['bold']};
  font-size: ${45 * Screen.widthRatio}px;
  height: fit-content;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  text-align: center;
  width: ${(props) => props.width || `${836 * Screen.widthRatio}px`};
  ${() => {
    return getModalStyle();
  }}
`;

export default ModalTitle;
